import { useUserEditorFormValues } from 'hooks/userEditor/useUserEditorFormValues';

export const useDeleteUserModalBusy = (userId: number) => {
  const { deleted } = useUserEditorFormValues(userId);

  return deleted;
};
